module.exports = __webpack_public_path__ + "img/招聘管理.d6855176.png";